<template>
  <div>
    <div class="row justify-content-center">
      <div
        class="col-md-8"
        v-if="!loading"
      >
        <form
          class="form-horizontal "
          role="form"
        >
          <h3 class="d-flex justify-content-center">
            [{{ member.cardid }}] {{ member.firstname }} {{ member.lastname }}
          </h3>
          <div class="justify-content-center text-center mt-4 ">

            <div
              class=""
              v-if="member.profilepic!=null && !tmpimgurl"
            ><img :src="$baseURL+'/api/members/profilepic/'+memberid" /></div>
            <div v-else-if="tmpimgurl"><img
                :src="tmpimgurl"
                width="300"
              /></div>
            <div
              v-else
              class=""
            ><img src="@/assets/images/profile.png" /></div>

            <div class="row mt-4 justify-content-center">

              <div class="col-md-5">
                <input
                  type="file"
                  name="image"
                  class="form-control"
                  @change="imagePreview($event)"
                ></div>
              <div class="col-md-2">
                <button
                  class="btn btn-success btn-block"
                  @click.prevent="uploadImage"
                >Upload</button>

              </div>
            </div>
          </div>
          <hr/>
          <div>
            <b-form inline>
            <label
              class="mr-sm-3"
              for="member_type_form"
            >Member Type</label>

            <b-form-radio-group
              v-model="member.type"
              id="member_type_form"
            >
              <b-form-radio value="STUDENT">STUDENT</b-form-radio>
              <b-form-radio value="STAFF">STAFF</b-form-radio>
              <b-form-radio value="PUBLIC">PUBLIC</b-form-radio>
            </b-form-radio-group>
          </b-form>
          </div>
          <div class="form-group mt-3 ">
            <v-field
              label="Member Card ID*"
              :v="$v.member.cardid"
            >
              <input
                type="text"
                id="cardid"
                placeholder="Member ID"
                class="form-control"
                autofocus
                v-model="member.cardid"
                @blur="$v.member.cardid.$touch()"
              />
            </v-field>
          </div>
          <div class="form-group">
            <v-field
              label="First Name*"
              :v="$v.member.firstname"
            >
              <input
                type="text"
                id="firstname"
                placeholder="First Name"
                class="form-control"
                autofocus
                v-model="member.firstname"
                @blur="$v.member.firstname.$touch()"
              />
            </v-field>
          </div>
          <div class="form-group">
            <v-field
              label="Last Name*"
              :v="$v.member.lastname"
            >
              <input
                type="text"
                id="lastname"
                placeholder="Last Name"
                class="form-control"
                autofocus
                v-model="member.lastname"
                @blur="$v.member.lastname.$touch()"
              />
            </v-field>
          </div>
          <div class="form-group">
            <v-field
              label="Nick Name"
              :v="$v.member.nickname"
            >
              <input
                type="text"
                id="nickname"
                placeholder="Nick Name"
                class="form-control"
                autofocus
                v-model="member.nickname"
                @blur="$v.member.nickname.$touch()"
              />
            </v-field>
          </div>
          <div class="form-group">
            <v-field
              label="Email*"
              :v="$v.member.email"
            >
              <input
                type="text"
                id="email"
                placeholder="Email"
                class="form-control"
                autofocus
                v-model="member.email"
                @blur="$v.member.email.$touch()"
              />
            </v-field>
          </div>

          <div class="form-group">
            <v-field
              label="Phone*"
              :v="$v.member.phone"
            >
              <input
                type="text"
                id="phone"
                placeholder="Phone"
                class="form-control"
                autofocus
                v-model="member.phone"
                @blur="$v.member.phone.$touch()"
              />
            </v-field>
          </div>
          <div class="form-group">
            <label
              for="birthDate"
              class="col-sm-3 control-label"
            >Date of Birth</label>
            <div class="">
              <date-picker
                v-model="member.birthdate"
                valueType="format"
              ></date-picker>
            </div>
          </div>
          <div class="form-group">
            <label
              for="country"
              class="col-sm-3 control-label"
            >Country </label>
            <div class="">
              <country-select
                v-model="member.country"
                :country="member.country"
                class="form-control"
              />
              <!--
              <region-select
                v-model="region"
                :country="country"
                :region="region"
              />
              -->
            </div>
            <div class="mt-1">
              <button
                @click.prevent="member.country = 'TH'"
                class="btn btn-secondary  btn-sm mr-1"
                type="button"
              >
                Thailand
              </button>
              <button
                @click.prevent="member.country = 'US'"
                class="btn btn-secondary  btn-sm mr-1"
                type="button"
              >
                USA
              </button>
              <button
                @click.prevent="member.country = 'AU'"
                class="btn btn-secondary  btn-sm mr-1"
                type="button"
              >
                Australia
              </button>
              <button
                @click.prevent="member.country = 'CA'"
                class="btn btn-secondary  btn-sm mr-1"
                type="button"
              >
                Canada
              </button>
              <button
                @click.prevent="member.country = 'CN'"
                class="btn btn-secondary  btn-sm mr-1"
                type="button"
              >
                China
              </button>
              <button
                @click.prevent="member.country = 'KR'"
                class="btn btn-secondary  btn-sm mr-1"
                type="button"
              >
                Korea
              </button>
            </div>
          </div>
          <b-form inline>
            <label
              class="mr-sm-3"
              for="member_gender_form"
            >Gender</label>

            <b-form-radio-group
              v-model="member.gender"
              id="member_gender_form"
            >
              <b-form-radio value="MALE">Male</b-form-radio>
              <b-form-radio value="FEMALE">Female</b-form-radio>
            </b-form-radio-group>
          </b-form>
          <!-- /.form-group -->
          <div class="form-group">
            <div class=" col-sm-offset-3 mt-3">
              <span class="help-block">*Required fields</span>
            </div>
          </div>
          <div>
            <transition name="slide-fade">
              <div
                v-if="isUpdateCompleted"
                class="alert alert-success"
                role="alert"
              >
                Update Success
              </div>
            </transition>
          </div>
          <div>
            <button
              type="submit"
              class="btn btn-primary btn-block"
              @click.prevent="updateMemberInfo"
              :class="{ invalid: $v.$invalid }"
            >
              Update
            </button>
          </div>
        </form>
        <!-- /form -->
      </div>
      <div
        v-else
        class="text-center my-2"
      >
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
    </div>

    <!--
    <div class="col-md-8">
      <form @submit.prevent="submit">
        <div
          class="form-group"
          :class="{ 'form-group--error': $v.name.$error }"
        >
          <label class="form__label">Name</label>
          <input class="form__input" v-model.trim="$v.name.$model" />
        </div>
        <div class="error" v-if="!$v.name.required">Name is required</div>
        <div class="error" v-if="!$v.name.minLength">
          Name must have at least {{ $v.name.$params.minLength.min }} letters.
        </div>
        <button
          class="button"
          type="submit"
          :disabled="submitStatus === 'PENDING'"
        >
          Submit!
        </button>
        <p class="typo__p" v-if="submitStatus === 'OK'">
          Thanks for your submission!
        </p>
        <p class="typo__p" v-if="submitStatus === 'ERROR'">
          Please fill the form correctly.
        </p>
        <p class="typo__p" v-if="submitStatus === 'PENDING'">Sending...</p>
      </form>
    </div>
    -->
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import Vue from "vue";

import vueCountryRegionSelect from "vue-country-region-select";
Vue.use(vueCountryRegionSelect);

import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  between,
  email,
  maxLength,
  numeric
} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  props: { memberid: Number },
  data() {
    return {
      loading: true,
      member: null,
      /*cardid: null,
      firstname: null,
      lastname: null,
      email: null,
      phone: null,
      country: null,
      region: null,*/
      country: null,
      isUpdateCompleted: false,
      pre_cardid: null,
      pre_firstname: null,
      pre_lastname: null,

      name: "",
      age: 0,
      submitStatus: null,

      image: "",
      filename: null,
      file: null,
      tmpimgurl: null,
      imgloading: false
    };
  },
  validations: {
    member: {
      cardid: {
        required,
        minLength: minLength(6),
        //maxLength: maxLength(6),
        //numeric
      },
      email: {
        required,
        email
      },
      firstname: {
        required
      },
      lastname: {
        required
      },
      phone: {
        required
      },
      nickname: {}
    }
  },
  mounted() {
    //console.log(this.member);
    //this.fillMemberInfo();

    this.getMember();
  },
  components: {
    DatePicker
    //vueCountryRegionSelect,
    //"vue-country-select": require("vue-country-select"),
  },
  methods: {
    imagePreview(event) {
      let selectedFile = event.target.files[0];
      this.file = selectedFile;
    },

    uploadImage() {
      this.imgloading = true;
      let formData = new FormData();

      if (this.file == null) {
        return false;
      }

      formData.append("image", this.file);
      formData.append("id", this.memberid);
      axios
        .post("/api/members/uploadpimg", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          //flash(response.data.message, "success");
          this.tmpimgurl = URL.createObjectURL(this.file);
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => {
          this.imgloading = false;
        });
    },
    async getMember() {
      //console.log(this.cardID);
      this.loading = true;
      await axios
        .get("/api/members/findinfo/" + this.memberid)
        .then(response => {
          //console.log(response.data);
          this.member = response.data;
          localStorage.setItem("latestMember", JSON.stringify(this.member));
          this.loading = false;
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.$router.push({ name: "Members" });
          }
        });
    },
    fillMemberInfo() {
      //console.log(this.member);
      /* this.cardid = this.member.cardid;
      this.firstname = this.member.firstname;
      this.lastname = this.member.lastname;
      this.email = this.member.email;
      this.phone = this.member.phone; */
    },
    async updateMemberInfo() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        //alert("All fields are not valid");
      } else {
        this.loading = true;

        await axios
          .post("/api/members/updateinfo", {
            member: this.member
          })
          .then(response => {
            //console.log("len " + response.data.data.length);
            //console.log(response.data);
            //this.isUpdateCompleted = true;
            this.loading = false;
            setTimeout(() => {
              //this.isUpdateCompleted = false;
            }, 1000);
          });
      }
      //return false;
    }
  }
};
</script>
